/* global axios */
import ApiClient from './ApiClient';

class AutomationOperationsAPI extends ApiClient {
  constructor() {
    super('automation_health', { accountScoped: true });
  }

  health() {
    return axios.get(`${this.baseUrl()}/automation_health`);
  }

  ruleHealth(params = {}) {
    return axios.get(`${this.baseUrl()}/automation_health/rules`, { params });
  }

  deadLetters(params = {}) {
    return axios.get(`${this.baseUrl()}/automation_dead_letters`, { params });
  }

  cadences(params = {}) {
    return axios.get(`${this.baseUrl()}/automation_operations/cadences`, {
      params,
    });
  }

  backfillCadencePreview(data = {}) {
    return axios.post(
      `${this.baseUrl()}/automation_operations/cadence_backfill_preview`,
      data
    );
  }

  cutoverCadencePreview(data = {}) {
    return axios.post(
      `${this.baseUrl()}/automation_operations/cadence_cutover_preview`,
      data
    );
  }

  pauseCadenceEnrollment(enrollmentId, data = {}) {
    return axios.post(
      `${this.baseUrl()}/automation_operations/pause_cadence_enrollment`,
      { ...data, enrollment_id: enrollmentId }
    );
  }

  resumeCadenceEnrollment(enrollmentId, data = {}) {
    return axios.post(
      `${this.baseUrl()}/automation_operations/resume_cadence_enrollment`,
      { ...data, enrollment_id: enrollmentId }
    );
  }

  deadLetter(id) {
    return axios.get(`${this.baseUrl()}/automation_dead_letters/${id}`);
  }

  execution(id) {
    return axios.get(`${this.baseUrl()}/automation_executions/${id}`);
  }

  transitionDeadLetter(id, actionName, data = {}) {
    return axios.post(
      `${this.baseUrl()}/automation_dead_letters/${id}/${actionName}`,
      data
    );
  }

  bulkTransitionDeadLetters(data = {}) {
    return axios.post(
      `${this.baseUrl()}/automation_dead_letters/bulk_transition`,
      data
    );
  }

  replayPlan(id, data = {}) {
    return axios.post(
      `${this.baseUrl()}/automation_executions/${id}/replay_plan`,
      data
    );
  }

  replay(id, data = {}) {
    return axios.post(
      `${this.baseUrl()}/automation_executions/${id}/replay`,
      data
    );
  }

  approveAction(id, data = {}) {
    return axios.post(
      `${this.baseUrl()}/automation_executions/${id}/approve_action`,
      data
    );
  }

  rejectAction(id, data = {}) {
    return axios.post(
      `${this.baseUrl()}/automation_executions/${id}/reject_action`,
      data
    );
  }

  reconcileUnknown(id, data = {}) {
    return axios.post(
      `${this.baseUrl()}/automation_executions/${id}/reconcile_unknown`,
      data
    );
  }
}

export default new AutomationOperationsAPI();
